import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, TextButton, useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import Modal from './Modal';
export default function SeeWhatItsLike(_0) {
    let { steps, as = 'button', testId } = _0, props = _object_without_properties(_0, [
        "steps",
        "as",
        "testId"
    ]);
    const overlayContext = useOverlayContext();
    const { t: texts } = useLocaleKeys('components.seeWhatItsLike');
    const testPrefix = "".concat(testId ? testId + '-' : '', "see-what-it-is-like");
    const handleOnClick = ()=>{
        return overlayContext.showModal({
            biName: 'modal',
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(Modal, {
                    steps: steps,
                    onClose: dismissModal,
                    testPrefix: testPrefix
                });
            },
            closeOnClickOutside: true,
            closeOnEscapeKey: true
        });
    };
    if (as === 'button') {
        return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
            bi: {
                name: 'open_see_what_its_like'
            },
            skin: "primaryOutline"
        }, props), {
            testId: testPrefix,
            onClick: handleOnClick,
            children: texts.buttonLabel()
        }));
    } else {
        return /*#__PURE__*/ _jsx(TextButton, _object_spread_props(_object_spread({
            bi: {
                name: 'open_see_what_its_like'
            }
        }, props), {
            testId: testPrefix,
            onClick: handleOnClick,
            children: texts.buttonLabel()
        }));
    }
}
